<template>
	<div class="album-detail maxW" style="margin-top:7%">
		<div class="album-nav-link">
			<router-link to="/home/albumList">{{$t('homepage.album')}}</router-link>
			<strong>
				<i>></i>{{ albumData.name }}
			</strong>
		</div>
		<div class="album-window clear">
			<div class="album-window-l">
				<img :src="BASE_URL + albumData.picture" />
			</div>
			<div class="album-window-r fr">
				<h2 class="albumb-w-h2">{{ albumData.name }}</h2>
				<div class="keyword-tips">
					<el-tag v-for="item in albumData.keyword_arr" :key="item">{{item}}</el-tag>
				</div>
				<ul class="clear">
					<li class="albumb-class fl">
						<div>
							<span class="video-count">{{ albumData.videocount }}</span>
							<span class="a-tit">{{$t('homepage.course')}}</span>
						</div>
					</li>
					<li class="albumb-study-count clear">
						<div>
							<span class="user-count">{{ albumData.usercount }}</span>
							<span class="a-tit">{{$t('homepage.learner')}}</span>
						</div>
					</li>
					<li class="albumb-study-count clear">
					</li>
				</ul>
			</div>
		</div>
		<div class="album-introduction">
			<div class="album-nav-tabs">
				<span :class="[albumTab == 1 ? 'nav-tab is-active' : 'nav-tab']" @click="taggleTabs(1)">{{$t('homepage.catalog')}}</span>
				<span :class="[albumTab == 2 ? 'nav-tab is-active' : 'nav-tab']" @click="taggleTabs(2)">{{$t('homepage.introduction')}}</span>
			</div>
			<div class="tab-panes">
				<div v-show="albumTab == 1" class="tab-pane">
					<ul class="album-ul">
						<li class="album-ls" v-for="(item, index) of albumListData" :key="index">
							<div class="album-tit clear" style="display:flex">
								<span class="tit-num fl">{{getChapter(index + 1)}}</span>
								<div class="album-tit-name">
									<span>{{ item.album_lname }}</span>
								</div>
							</div>
							<ul>
								<li class="album-ls2 clear" v-for="(item1, index1) of item.video" :key="index1">
									<span class="tit-num fl">{{ index1 + 1 }}</span>
									<div class="ls-content clear">
										<span class="profile" :title="item1.name">{{ item1.name }}</span>
										<template v-if="item1.origin == 0">
											<i class="fr">{{$t('homepage.video')}}</i>
											<div class="album_btns">
												<el-button type="primary" @click="downloadFile(0,item1.is_download,item1.res_id,item1.source_url)">{{$t('global.download')}}</el-button>
												<el-button type="primary" @click="checkResource(0, item1.res_id)">{{$t('global.check')}}</el-button>
											</div>
										</template>
										<template v-else-if="item1.origin == 1">
											<i class="fr">{{$t('homepage.test')}}</i>
											<div class="album_btns">
												<el-button type="primary" @click="downloadFile(1, 1, item1.res_id, item1.source_url)">{{$t('global.download')}}</el-button>
												<el-button type="primary" @click="checkResource(1, item1.res_id)">{{$t('global.check')}}</el-button>
											</div>
										</template>
										<template v-else>
											<i class="fr">{{$t('homepage.resource')}}</i>
											<div class="album_btns">
												<el-button type="primary" @click="downloadFile(2,item1.is_download,item1.res_id,item1.source_url)">{{$t('global.download')}}</el-button>
												<el-button type="primary" @click="checkResource(2, item1.res_id)">{{$t('global.check')}}</el-button>
											</div>
										</template>
									</div>
								</li>
							</ul>
						</li>
					</ul>
				</div>
				<div v-show="albumTab == 2" class="tab-pane">
					<div class="albumIntroduction clear">
						<a class="avatar-path" href="javascript:;" rel="noopener noreferrer">
							<img src="../../../../assets/images/morentouxiang.png" />
						</a>
						<div class="albumIntroduction-r">
							<div class="about-teacher clear">
								<div class="teacher-info fl">
									<a href="javascript:;" rel="noopener noreferrer">{{ albumData.custom_speaker }}</a>
								</div>
							</div>
							<ul class="other-infos clear">
								<li class="fl'">
									<div>
										<i id="video_num">{{ albumIntroductData.video_num }}</i>
										<span>{{$t('homepage.course')}}</span>
									</div>
								</li>
								<li class="fl'">
									<div>
										<i id="video_click">{{ albumIntroductData.video_click }}</i>
										<span>{{$t('homepage.playCounts')}}</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="album-profile">
						<span>{{$t('homepage.introduction')}}</span>
						<p v-html="profile == '' ? $t('global.noData') : profile"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				user_login_id: this.$g.user_id,
				albumId: this.$route.query.id,
				albumData: {},
				is_fav: 0,
				albumTab: 1,
				albumListData: [],
				albumIntroductData: {},
				profile: "",
				create_id: null,
				is_relation: 0,
				outline_url: "",
				outline_path: "",
				outline_name: "",
				teaching_url: "",
				teaching_path: "",
				teaching_name: "",
				showShare: false, //显示分享弹窗
				changeCopy: 1, // 选择复制
				shareLink: '', // 分享地址
				videoSign: '',
			};
		},
		created() {
			this.getAlbum();
			this.getAlbumList();
		},
		methods: {
			// 获取专辑数据：
			getAlbum() {
				let success = data => {
					this.videoSign = data.data.album_sign
					this.albumData = data.data;
					this.is_fav = data.data.is_fav;
					this.profile = data.data.profile;

					this.outline_url = data.data.outline_url;
					this.outline_path = data.data.outline_path;
					this.outline_name = data.data.outline_name;

					this.teaching_url = data.data.teaching_url;
					this.teaching_path = data.data.teaching_path;
					this.teaching_name = data.data.teaching_name;

					this.albumId = data.data.id
                    sessionStorage.setItem('sharePath', this.BASE_URL + '/home/albumDetail?id=' + data.data.id)
					
					this.create_id = data.data.create_id;
				};
				this.$ajax({
					url: "api/albumcompany/getalbum_info",
					method: "get",
					params: {
						album_sign: sessionStorage.getItem('album_sign')
					},
					func: {
						success: success
					}
				});
			},
			// 多语言，获取章节序列号
			getChapter(index){
				return this.$t('homepage.chapter').replace(/1/g, index);
			},
			// 课程目录/专辑介绍的tab切换：
			taggleTabs(num) {
				this.albumTab = num;
			},
			downloadFile(type, is_download, id, url) {
				if(localStorage.getItem('token')) {
					if (url == "null") {
						url = "";
					}
					if (is_download == 0) {
						this.$message.warning(this.$t('homepage.canotDown'));
						return false;
					}
					switch (type) {
						case 0:
							window.location.href =
								this.BASE_URL + "/index/openclass/videodownload?id=" + id;
							break;
						case 1:
							window.location.href =
								this.BASE_URL + "/index/test/download_test?id=" + id;
							break;
						case 2:
							window.location.href =
								this.BASE_URL + "/index/resource/resourcedownload?id=" + id;
							break;
					}
                }else{
                    this.$message.warning(this.$t('homepage.needLogin'))
                }
			},
			checkResource(type, resId) {

				if(localStorage.getItem('token')) { 
					let url = location.origin;
					switch (type) {
						case 0:
							url = url + "/home/openclassDetail?id=" + resId + '&album_id=' + this.albumId;
							window.open(url)
							break;
						case 1:
							url = url + "/home/albumPaper?id=" + resId;
							window.open(url);
							break;
						case 2:
							url = url + "/home/resourceDetail?id=" + resId;
							window.open(url)
							break;
					}
				}else{
                    this.$message.warning(this.$t('homepage.needLogin'))
				}
			},
			// 获取专辑数据：
			getAlbumList() {
				let success = data => {
					this.albumListData = data.data;
				};
				this.$ajax({
					url: "api/album/getalbums_l",
					method: "get",
					params: {
						albumid: this.albumId
					},
					func: {
						success: success
					}
				});
			},
			// 专辑介绍：
			getAlbumIntroduct() {
				let success = data => {
					this.albumIntroductData = data.data[0];
					this.is_relation = data.data[0].is_relation;
				};
				this.$ajax({
					url: "api/user/user",
					method: "get",
					params: {
						id: this.create_id
					},
					func: {
						success: success
					}
				});
			},
		},
	};
</script>
<style lang="scss">
	.share_text {
		font-size: 16px;
		.el-radio-group {
			margin: 20px 0 15px 0;
		}
		.el-radio__label {
			font-size: 15px;
		}
	}
	.album-nav-link {
		padding: 24px 0;
		font-size: 16px;

		a {
			color: #333;
		}

		i {
			margin: 0 6px;
		}

		strong {
			color: #999;
		}
	}

	.album-window {
		padding-bottom: 20px;

		.album-window-l {
			display: inline-block;
			width: 470px;
			height: 270px;
			background-color: #fff;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.album-window-r {
			display: inline-block;
			box-sizing: border-box;
			width: calc(100% - 490px);
			padding: 20px 30px 0;
			height: 270px;
			background-color: #fff;

			.albumb-w-h2 {
				font-size: 22px;
				font-weight: bold;
				line-height: 30px;
				height: 30px;
			}

			.keyword-tips {
				height: 30px;
				padding: 16px 0 22px;

				.el-tag {
					font-size: 14px;
					color: #3589B2;
					height: 30px;
					line-height: 30px;
					margin-right: 10px;
					background: #E1F3FF;
					border: 0 none;
				}
			}

			span {
				font-size: 14px;
			}

			.a-tit {
				// display: inline-block;
				// width: 80px;
				// margin-right: 10px;
			}

			.albumb-class,
			.albumb-study-count {
				padding: 8px 0;
				overflow: hidden;

				>div {
					border-left: 1px solid #D8D8D8;
					width: 100px;
					height: 40px;
					text-align: center;

					>span {
						display: block;
						color: #000;

						&:first-child {
							transform: translateY(-8px);
							height: 26px;
							line-height: 26px;
							font-size: 24px;
							word-spacing: 0.18px;
						}

						&:last-child {
							line-height: 20px;
							font-size: 14px;
							color: #666666;
							word-spacing: 0.11px;
						}
					}
				}
			}

			.albumb-study-count>div {
				border-right: 1px solid #D8D8D8;
			}

			.video-count {
				color: #db9c00;
			}

			.albumb-collect {
				height: 40px;
				line-height: 40px;

				.ipng {
					width: 25px;
					height: 40px;
					cursor: pointer;
				}

				.collect {
					background-position: -465px -768px;
				}

				.uncollect {
					background-position: -440px -768px;
				}
			}

			.albumb-share {
				margin-top: 40px;
				height: 20px;
				line-height: 20px;

				.a-tit {
					margin-right: 40px;
				}

				.share_ele {
					>div {
						line-height: 20px;

						>a {
							margin: 0;
							width: 20px;
							height: 20px;
						}
					}
				}
			}
		}
	}

	.album-introduction {
		background-color: #fff;
		margin-bottom: 40px;

		.album-nav-tabs {
			border-bottom: 1px solid #EFEFEF;

			// box-shadow: 0 2px 4px 0 rgba(195, 195, 195, 0.3);
			.is-active {
				color: #0057A7;
				position: relative;
				border-left: 1px solid #DDDDDD;
				border-right: 1px solid #DDDDDD;
			}

			.is-active::after {
				position: absolute;
				// top: 0;
				bottom: -2px;
				left: 0;
				//   right: -20px;
				content: "";
				width: 100%;
				height: 5px;
				background: #fff;
				//   border-bottom: 40px solid #edf5ff;
				//   border-top: 0 none;
				//   border-left: 0px solid transparent;
				//   border-right: 20px solid transparent;
			}

			.nav-tab {
				display: inline-block;
				width: 160px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				cursor: pointer;

				&:first-child {
					border-left: 0 none;
				}
			}
		}

		.tab-pane {
			min-height: 300px;
			padding: 40px 40px 20px 45px;
		}

		.album-ul {
			.album-tit {
				font-size: 14px;
				line-height: 48px;
				height: 48px;
				background: #D6E4F2;
				// color: #3e6099;
				border-bottom: 1px solid #efefef;
			}

			.tit-num {
				display: inline-block;
				width: 100px;
				text-align: center;
			}

			.album-ls2 {
				font-size: 14px;
				line-height: 48px;
				height: 48px;
				border-bottom: 1px solid #efefef;

				.ls-content {
					position: relative;

					.profile {
						display: inline-block;
						vertical-align: top;
						max-width: 60%;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					i {
						margin-right: 5px;
					}

					.album_btns {
						display: none;
						position: absolute;
						top: 0;
						right: 0;

						.el-button {
							width: 56px;
							height: 32px;
							padding: 0;
							font-size: 14px;
							background: #4477C3;
							border: 0 none;
						}
					}
				}
			}

			.ls-content:hover>.album_btns {
				display: block;
			}

			.ls-content:hover>.album-ls2 {
				background-color: #effaff;
			}
		}

		.albumIntroduction {
			border-bottom: 1px dashed #e0e0e0;
			padding-bottom: 25px;
			margin-bottom: 30px;

			.avatar-path {
				display: block;
				float: left;
				width: 80px;
				height: 80px;
				border-radius: 50%;
				overflow: hidden;
				cursor: auto;

				// box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
				img {
					width: 100%;
					height: 100%;
				}
			}

			.albumIntroduction-r {
				margin-left: 100px;

				.about-teacher {
					display: inline-block;
					width: 100%;
					height: 30px;
					line-height: 30px;
					font-size: 22px;
				}

				.teacher-info {
					a {
						display: inline-block;
						line-height: 30px;
						font-size: 22px;
						// color: #2f6d8c;
						font-weight: bold;
						vertical-align: middle;
						cursor: auto;
					}

					strong {
						display: inline-block;
						padding: 0 15px;
						font-size: 14px;
						line-height: 30px;
						border-radius: 30px;
						color: #ffffff;
						background: #338efc;
						// padding: 7px 15px;
						margin-left: 15px;
						vertical-align: middle;
					}
				}

				.introduction-try {
					i {
						text-align: center;
						line-height: 40px;
						color: #ffffff;
						text-indent: 25px;
						margin-left: 40px;
						cursor: pointer;
					}

					.focus {
						background-position: -381px -473px;
						width: 100px;
						height: 40px;
					}

					.alfocus {
						background-position: -271px -473px;
						width: 100px;
						height: 40px;
					}
				}

				.other-infos {
					// padding-top: 20px;
					// span {
					//   font-size: 14px;
					//   color: #db9c00;
					//   margin-right: 40px;
					// }
					margin-top: 14px;

					>li {
						display: inline-block;
						padding: 9px 0;

						>div {
							width: 100px;
							height: 30px;
							text-align: center;
							border-left: 1px solid #DDDDDD;
							border-right: 1px solid #DDDDDD;

							>i {
								display: block;
								height: 24px;
								line-height: 24px;
								font-size: 18px;
								transform: translateY(-10px);
							}

							>span {
								line-height: 16px;
								font-size: 12px;
								color: #666666;
							}
						}

						&:last-child>div {
							border-left: 0 none;
						}
					}
				}
			}
		}

		.album-profile {
			font-size: 14px;
			line-height: 20px;

			// padding-bottom: 80px;
			p {
				display: inline;
				// color: #1d5673;
				text-align: left;
				word-spacing: 0.16px;
			}
		}

		.album-outline,
		.album-appraise {
			.downBtn {
				margin-bottom: 20px;
			}
		}

		.empty-bgc-img {
			display: inline-block;
			width: 100%;
			height: 500px;
			background-image: url("../../../../../public/images/image08.png");
			background-size: 100%;
			position: relative;

			.i_resourceMask {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.1);
				text-align: center;
				visibility: hidden;
				opacity: 0;
				-moz-transition: all 0.35s ease-in;
				-webkit-transition: all 0.35s ease-in;
				-o-transition: all 0.35s ease-in;
				transition: all 0.35s ease-in;
			}

			&:hover .i_resourceMask {
				visibility: visible;
				opacity: 1;
			}

			span {
				font-size: 24px;
				color: #ffffff;
				background: rgba(0, 0, 0, 0.1);
				border-radius: 15px;
				height: 70px;
				line-height: 70px;
				display: block;
				width: 370px;
				text-align: center;
				position: absolute;
				top: 45%;
				left: 50%;
				margin-left: -170px;
			}
		}
	}

	/* ----------emoji start */
	.emoji {
		width: 380px;
		height: 186px;
		bottom: 30px;
		background: #fff;
		z-index: 10;
		padding: 10px;
		margin-right: 10px;
	}

	.emoji .emoji-controller {
		height: 36px;
		overflow: hidden;
		margin-bottom: 0;
	}

	.emoji .emoji-controller li {
		float: left;
		width: 76px;
		font-size: 12px;
		line-height: 36px;
		cursor: pointer;
		text-align: center;
		position: relative;
		text-align-last: initial;
	}

	.emoji .emoji-controller li.active::after {
		content: "";
		width: 100%;
		height: 1px;
		background: #0689dd;
		left: 0;
		bottom: 4px;
		position: absolute;
	}

	.emoji .emoji-container {
		height: 140px;
		overflow-y: auto;
		overflow-x: hidden;
		position: relative;
	}

	.emoji .emoji-container li {
		font-size: 0;
		padding: 5px;
	}

	.emoji .emoji-container li a {
		float: left;
		overflow: hidden;
		height: 35px;
		transition: all ease-out 0.2s;
		border-radius: 4px;
	}

	.emoji .emoji-container li a:hover {
		background-color: #d8d8d8;
		border-color: #d8d8d8;
	}

	.emoji .emoji-container li a span {
		width: 25px;
		height: 25px;
		display: inline-block;
		border: 1px solid transparent;
		cursor: pointer;
	}

	.vueEmoji {
		position: absolute;
		right: 112px;
		bottom: 74px;
		margin: 0;
		box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
	}

	/* ----------emoji end */
</style>
